<template>
  <component :is="link ? nuxtLinkComponent : 'span'" :to="link ? link : null"
    >{{ prefix && prefix + '&nbsp;'
    }}{{ currencyFilter(value) }}&thinsp;₽</component
  >
</template>

<script setup lang="ts">
defineProps({
  value: {
    type: Number,
    default: 0,
  },
  prefix: {
    type: String,
    default: '',
  },
  link: {
    type: String,
    default: '',
  },
});
const nuxtLinkComponent = shallowRef(defineNuxtLink({}));
function currencyFilter(value: number) {
  if (!value) return '0';
  return (Math.ceil(value * 100) / 100).toLocaleString('ru');
}
</script>
<style scoped lang="scss" src="./CurrencyScss.scss"></style>
